import { authHeader, handleResponse } from "../_helpers";
import { BASE_URL, CPAS_CHARITY_ID } from "../../common/constant";

export const homePageService = {
  getHomePageSettings,
  getDonationWidgetData,
  getDonorWallData,
  getPayPartners,
};

async function getHomePageSettings() {
  const requestOptions = {
    method: "POST",
    headers: authHeader(),
  };
  const url = BASE_URL + "/v1/Home/homePageConfiguration?charityId=" + CPAS_CHARITY_ID;
  return fetch(url, requestOptions)
    .then(handleResponse)
    .then((result) => {
      if (
        result.data !== null &&
        result.data !== undefined &&
        result.data.status === 1
      ) {
        return result.data;
      } else {
        return false;
      }
    })
    .catch((error) => {
      return false;
    });
}

async function getDonationWidgetData(appealId) {
  const requestOptions = {
    method: "POST",
    headers: authHeader(),
  };
  const url =
    BASE_URL +
    "/v1/Donation/donationWidget?charityId=" +
    CPAS_CHARITY_ID +
    "&appealId=" +
    appealId;
  return fetch(url, requestOptions)
    .then(handleResponse)
    .then((result) => {
      return result.data;
    })
    .catch((error) => {
      return { status: 0 };
    });
}

async function getDonorWallData(pageNo, pageSize) {
  const requestOptions = {
    method: "POST",
    headers: authHeader(),
  };
  const url =
    BASE_URL +
    "/v1/Donation/donorWall?charityId=" +
    CPAS_CHARITY_ID +
    "&pageNumber=" +
    pageNo +
    "&pageSize=" +
    pageSize;
  return fetch(url, requestOptions)
    .then(handleResponse)
    .then((result) => {
      if (
        result.data !== null &&
        result.data !== undefined &&
        result.data.status === 1
      ) {
        return result.data;
      } else {
        return [];
      }
    })
    .catch((error) => {
      return [];
    });
}

async function getPayPartners(charityId) {
  const requestOptions = {
    method: "POST",
    headers: authHeader(),
  };
  // const url = BASE_URL + "/v1/Donation/getPayPartners?charityId=" + CPAS_CHARITY_ID;
  const url = BASE_URL + "/v1/Donation/getPayPartners?charityId=" + charityId;
  return fetch(url, requestOptions)
    .then(handleResponse)
    .then((result) => {
      if (
        result.data !== null &&
        result.data !== undefined &&
        result.data.status === 1
      ) {
        return result.data;
      } else {
        return [];
      }
    })
    .catch((error) => {
      return [];
    });
}